import httpFactory from '@adjust/dashboard-core/api/instance/http-factory';

const http = httpFactory({ baseURL: configurationURL.accounts.baseUrl });

export default http;

export const getUserDetails = ({ accountId, id }) =>
  http.get(`/accounts/${accountId}/users/${id}`).then(resp => resp.data);

export const resetApiToken = data => http.patch(`/user/api_token`, data).then(resp => resp.data);

export const changePassword = ({ account_id, id, password, new_password, confirmation }) =>
  http
    .patch(`/accounts/${account_id}/users/${id}/change_password`, {
      password,
      new_password,
      confirmation,
    })
    .then(response => ({
      response: response.data || {},
    }))
    .catch(response => ({ error: response.data }));

export const changeEmail = ({ accountId, id, password, email }) =>
  http
    .patch(`/accounts/${accountId}/users/${id}/change_email`, {
      email,
      password,
    })
    .then(resp => resp.data);

export const resendConfirmationEmail = ({ accountId, id }) =>
  http
    .patch(`/accounts/${accountId}/users/${id}/resend_confirmation_email`, {
      id,
      account_id: accountId,
      action: 'resend_confirmation_email',
    })
    .then(resp => resp.data);

export const getUsers = ({ accountId }) => http.get(`/accounts/${accountId}/users`).then(response => response.data);

export const getAdvancedUsers = ({ accountId }) =>
  http.get(`/accounts/${accountId}/permission_users`).then(response => response.data);

export const updateUser = (accountId, id, payload) =>
  http.put(`/accounts/${accountId}/users/${id}`, payload).then(resp => resp.data);

export const updateUserPermissions = ({ accountId, id, payload }) =>
  http.put(`/accounts/${accountId}/users/${id}/roles`, payload).then(resp => resp.data);

export const deleteUser = (accountId, id) => http.delete(`/accounts/${accountId}/users/${id}`).then(resp => resp.data);

export const postUser = ({ accountId, payload }) =>
  http.post(`/accounts/${accountId}/users`, payload).then(resp => resp.data);
